<template>
  <div>
    <v-navigation-drawer
      v-model="$root.groupProfile.leftNav"
      color="background"
      left
      app
      hide-overlay
      disable-resize-watcher
      class="pt-0"
    >
      <template slot="prepend">
        <v-row justify="center" align-content="center" class="py-2">
          <v-btn
            @click="$router.push('/location-groups'); $root.leftNav = true"
            color="primary"
            text
            class="text-capitalize"
          >
            <v-icon left small>fas fa-arrow-left</v-icon>Back To Groups
          </v-btn>
        </v-row>
        <v-divider></v-divider>
      </template>
      <template slot="append">
        <v-divider></v-divider>
        <v-row justify="center" align-content="center">
          <v-btn
            @click="deleteLocationGroup"
            block
            text
            color="error"
            class="text-capitalize"
            height="50px"
          >
            <v-icon left small>delete</v-icon>Delete Group
          </v-btn>
        </v-row>
      </template>
      <v-container>
        <v-layout column>
          <v-list>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/location-group-profile/${$route.params.id}/details`"
            >
              <v-list-item-title>Group Details</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/location-group-profile/${$route.params.id}/locations`"
            >
              <v-list-item-title>Group Locations</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-scroll-x-transition mode="out-in">
      <router-view></router-view>
    </v-scroll-x-transition>
  </div>
</template>

<script>
import { LocationGroupAPI } from '../../../clients/locationGroups/locationGroups.api'
export default {
  mounted() {
    this.$root.$on('item-deleted', (s) => {
      this.$router.push('/location-groups')
    })
  },
  async created() {
    this.$root.leftNav = false
  },
  destroyed() {
    this.$root.leftNav = true
  },
  methods: {
    deleteLocationGroup() {
      this.openDeleteModal({ title: `Delete location group?`, callback: () => LocationGroupAPI.deleteLocationGroup(this.$route.params.id) })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
